import PropTypes from 'prop-types';
import React from 'react';

import i18n from '../../i18n';
import Conversation from '../../models/Conversation';
import User from '../../models/User';
import { ButtonModifyAnExchange } from './ButtonModifyAnExchange';
import { Button } from '@homeexchange/panorama';

export default class ButtonInfos extends React.Component {
    static propTypes = {
        conversation: PropTypes.instanceOf(Conversation).isRequired,
        user: PropTypes.instanceOf(User).isRequired
    };

    constructor(props) {
        super(props);
        this.handleInfos = this.handleInfos.bind(this);
    }

    render() {
        if (
            this.props.conversation.isFinalized() ||
            this.props.conversation.isInExchangeModificationFlowAndShouldBuyGp()
        ) {
            return (
                <>
                    <ButtonModifyAnExchange
                        conversation={this.props.conversation}
                        user={this.props.user}
                        isFullWidth
                    />

                    <Button
                        hierarchy="secondary"
                        isFullWidth
                        onClick={this.handleInfos}
                        {...(this.props.conversation.isInExchangeModificationFlowAndShouldBuyGp() && {
                            id: 'view-details-initial-exchange-cta'
                        })}
                    >
                        {this.props.conversation.isInExchangeModificationFlowAndShouldBuyGp()
                            ? i18n.t('exchange:View_initial_exchange_details_cta')
                            : i18n.t('exchange:see_details')}
                    </Button>
                </>
            );
        }

        return false;
    }

    handleInfos() {
        document.dispatchEvent(
            new CustomEvent('request_card', {
                detail: {
                    view: 'infos',
                    animate: false
                }
            })
        );
    }
}
